module.exports = __webpack_public_path__ + "img/staple.0b2ec01e.svg";